module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/LocationIcon.e6b502b6.svg";